import { apiDelete, apiGet, apiPatch, apiPost, apiPut } from "./api";

export async function getCategories(params = {}) {
  return apiGet("/catalog/categories/", params);
}

export async function getAdminCategories(params = {}) {
  return apiGet("/catalog/admin/categories/", params);
}

export async function createCategory(payload) {
  return apiPost("/catalog/admin/categories/", payload);
}

export async function updateCategory(categoryId, payload) {
  return apiPut(`/catalog/admin/categories/${categoryId}/`, payload);
}

export async function patchCategory(categoryId, payload) {
  return apiPatch(`/catalog/admin/categories/${categoryId}/`, payload);
}

export async function deleteCategory(categoryId) {
  return apiDelete(`/catalog/admin/categories/${categoryId}/`);
}
